
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import * as Sentry from "@sentry/react";
import { ErrorBoundary } from '@sentry/react'
import { alpha, useTheme } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ConfirmProvider } from "material-ui-confirm";
import { SnackbarProvider } from 'notistack';
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RTL from "./components/RTL";
// import ErrorBoundary from './error-boundary.jsx';
import { initAppData, getAlgInfo } from "./redux/slices/app";
import routes from "./routes";
import { startFirebaseAnalytics } from "./utils/firebase";
import { dispatch } from "@/redux/store.js";
import useIntercom from './hook/useIntercom';

function App() {
  const { loading, appVersion } = useSelector((state) => state.app);
  const { t } = useTranslation();
  const router = createBrowserRouter(routes());
  const theme = useTheme()
  const { user } = useSelector(state => state?.user);
  const { initService } = useIntercom();

  useEffect(() => {
    if(user){
      initService();

    }
  }, [user]);

  useEffect(() => {
    // close page loader.
    document.querySelector("#dom-loader-wrapper")?.remove();
    if (loading['getCountries'] || appVersion) return;
    // start collect firebase analytics on app inited.
    startFirebaseAnalytics();
    //先获取加密参数再初始化
    dispatch(getAlgInfo()).then((res)=>{
      initAppData();
    })
  }, []);

  return <LocalizationProvider dateAdapter={AdapterDateFns}>
    <RTL>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        style={{ maxWidth: '520px' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }} />
      <ConfirmProvider defaultOptions={{
        dialogProps: {
          maxWidth: 'dialogXS',
        },
        title: '',
        contentProps: {
          sx: {
            padding: '32px',
            paddingBottom: '0px',
            boxSizing: 'border-box',
            maxWidth: '420px',
            fontWeight: '400'
          }
        },
        dialogActionsProps: {
          sx: {
            padding: '32px'
          }
        },
        confirmationText: t('ok'),
        cancellationText: t('cancel'),
        confirmationButtonProps: { autoFocus: true, variant: 'contained' },
        cancellationButtonProps: {
          variant: 'outlined',
          sx: {
            color: theme.palette.text.primary,
            borderWidth: 0,
            backgroundColor:
              alpha(theme.palette.text.primary, 0.05)
          }
        },
      }}>
        <ErrorBoundary fallback={<p>Error occurred.</p>}>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </ConfirmProvider>
    </RTL>
  </LocalizationProvider>
}

export default App;
